import $ from 'jquery';
import ComponentBasePrototype from 'ComponentBasePrototype';
import _ from 'lodash';

export default class ShareAndFollow extends ComponentBasePrototype {

  get h1Text() { // eslint-disable-line
    return $('h1').filter(':visible').text();
  }

  build() {
    this.setHandlers();
    this.setTwitterShareText();
    this.setSmallerIconMargin();

    return true;
  }

  setHandlers() {
    this.node.on('click', '.share-follow__facebook-share', (event) => {
      event.preventDefault();
      const shareUrl = `http://www.facebook.com/sharer/sharer.php?u=${window.location.href}`;
      this.openWindow(shareUrl, 350, 520);
    });

    this.node.on('click', '.share-follow__linkedin-share', (event) => {
      event.preventDefault();
      let shareUrl = this.node.find('.share-follow__linkedin-share').attr('href');

      if (typeof shareUrl !== 'undefined' && shareUrl.indexOf('&title=') === -1) {
        const title = this.h1Text ? this.h1Text : document.title;
        shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&title=${title}`;
      }

      this.openWindow(encodeURI(shareUrl), 520, 570);
    });

    this.node.on('click', '.share-follow__twitter__share', (event) => {
      event.preventDefault();
    });
  }

  /** Twitter share text priorities:
   *  1. Editor has set a specific text to use
   *  2. H1 text (because e.g. job pages don't have relevant page title)
   *  3. Page title
   */
  setTwitterShareText() {
    const twLink = this.node.find('.share-follow__twitter__share');

    if (twLink) {
      let twLinkHref = twLink.attr('href');

      if (typeof twLinkHref !== 'undefined' && twLinkHref.indexOf('&text=') === -1) {
        if (this.h1Text) {
          twLinkHref = `${twLinkHref}&text=${this.h1Text}`;
        } else {
          twLinkHref = `${twLinkHref}&text=${document.title}`;
        }

        twLink.attr('href', twLinkHref);
      }
    }
  }

  openWindow(url, winHeight, winWidth) { // eslint-disable-line
    const winTop = (screen.height / 2) - (winHeight / 2);
    const winLeft = (screen.width / 2) - (winWidth / 2);

    window.open(url, 'share', `top=${winTop},left=${winLeft},toolbar=0,status=0,width=${winWidth},height=${winHeight}`);
  }

  setSmallerIconMargin() {
    // set smaller margin for icon if there are more than 4
    // because then icons are wrapped in two lines
    if (this.node.hasClass('share-follow--large')) {
      const numberOfIcons = _.forEach(this.node.find('.icon')).length;
      if (numberOfIcons > 4) {
        this.node.find('.share-follow__icon').addClass('share-follow__icon--reduce-margin');
      }
    }
  }
}

/* eslint-disable */
window.twttr = (function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0],
    t = window.twttr || {};
  if (d.getElementById(id)) return t;
  js = d.createElement(s);
  js.id = id;
  js.src = 'https://platform.twitter.com/widgets.js';
  fjs.parentNode.insertBefore(js, fjs);

  t._e = [];
  t.ready = function(f) {
    t._e.push(f);
  };

  return t;
}(document, 'script', 'twitter-wjs'));

(function(d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = '//connect.facebook.net/fi_FI/sdk.js#xfbml=1&version=v2.6';
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'facebook-jssdk'));

/* eslint-enable */
